// Central registry of real, provided image assets.
// Any asset NOT listed here has not been provided yet and must render as an
// elegant PlaceholderMockup (see components/ui/PlaceholderMockup.tsx) instead
// of a generic stand-in image.

export const FULL_MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/nfVwKJ36eYri3rLwJjoeEj/ChatGPT_Image_15_ago_2026__14_44_05__1_-removebg-preview.png';

// Tomo cover / mood images
export const TOMO_IMAGES = {
  tomo1: 'https://cdn.magicpatterns.com/patterns/generated-images/77e1aa01-045c-496e-b726-e7f62ab42f10.jpg',
  tomo2: 'https://cdn.magicpatterns.com/patterns/generated-images/cebcd71a-8237-46ab-a489-8beaeb1d0894.jpg',
  tomo3: 'https://cdn.magicpatterns.com/patterns/generated-images/329a510f-52a8-464b-882c-367131c626d2.jpg',
  tomo4: 'https://cdn.magicpatterns.com/patterns/generated-images/d16655f8-6076-4b5a-a741-605ccd27f6ae.jpg',
  tomo5: 'https://cdn.magicpatterns.com/patterns/generated-images/e11447e0-b356-4823-95eb-96cc1c61e3e5.jpg'
};

// Bono images
export const BONO_IMAGES = {
  bono1: 'https://cdn.magicpatterns.com/patterns/generated-images/71de5942-05d7-4c29-8407-39bb2ef6a2d4.jpg',
  bono2: 'https://cdn.magicpatterns.com/patterns/generated-images/a39fea2f-ca51-4787-a2c4-33513291d5f4.jpg',
  bono3: 'https://cdn.magicpatterns.com/patterns/generated-images/74a4db35-2660-4631-84bf-8364a6fab105.jpg',
  bono4: 'https://cdn.magicpatterns.com/patterns/generated-images/c8426f84-23f9-4fa5-b094-70f2927ed400.jpg',
  bono5: 'https://cdn.magicpatterns.com/patterns/generated-images/295ca0f8-dbd3-4b0d-bb4b-18bd0a01dc42.jpg'
};

// Kit de Ejecución images
export const KIT_IMAGES = {
  mapaDePista: 'https://cdn.magicpatterns.com/patterns/generated-images/98e2afb0-f525-4576-a5b7-cfcfa60257bd.jpg',
  programador12Meses: 'https://cdn.magicpatterns.com/patterns/generated-images/fb7823c0-5062-498c-b05b-b65d62f63fd9.jpg'
};

// "Mira por dentro" carousel / proof section images
export const INSIDE_IMAGES: Record<string, string> = {
  'Ficha Técnica': 'https://cdn.magicpatterns.com/patterns/generated-images/b4cacef1-04bf-41c9-8bf0-95a3a4304ce2.jpg',
  'Semáforo de Errores': 'https://cdn.magicpatterns.com/patterns/generated-images/eee7b9a7-1437-494c-808a-b0f7808102f9.jpg',
  'Escalera de Progresión': 'https://cdn.magicpatterns.com/patterns/generated-images/22bb9a1c-7b7a-47c2-a0dc-19d1d03138ba.jpg',
  'Tip del Pro': 'https://cdn.magicpatterns.com/patterns/generated-images/dab3f626-d6e9-467a-82f5-038cd9db98f7.jpg',
  'Ejemplo de Ejercicio': 'https://cdn.magicpatterns.com/patterns/generated-images/8edc159d-8039-44c7-87f8-00d45191c56c.jpg',
  'Diagrama de Pista': 'https://cdn.magicpatterns.com/patterns/generated-images/c28f67d4-62c5-44fa-80d9-f88f421e0dea.jpg',
  'Planificación de Sesión': 'https://cdn.magicpatterns.com/patterns/generated-images/651e3ea2-eade-4ad5-8e4f-a1d1d7379a4d.jpg',
  'Metodología de Trabajo': 'https://cdn.magicpatterns.com/patterns/generated-images/30c29c52-d4ab-4682-ab54-2523fe2156d7.jpg'
};
